import { Component, EventEmitter, Input, OnInit, Output, ElementRef } from '@angular/core';
import { gamePercentAgent } from 'src/app/apis/agent.service';

@Component({
  selector: 'app-form-lotto',
  templateUrl: './form-lotto.component.html',
  styleUrls: ['./form-lotto.component.scss']
})
export class FormLottoComponent implements OnInit {
  @Input() ReadOnly = false;

  @Input() Data: any;
  @Output() DataChange = new EventEmitter();

  activeGame = '';
  activeGameListCode = '';

  constructor() {
  }

  ngOnInit() {
    this.onActiveLottoSetting('ASKMELOTTO');
  }

  onChangePercent(game_code: string) {
    const game = this.Data.profit_sharing.find((c) => c.game_code === game_code) as gamePercentAgent;
    if (game.percent_own < 0) {
      game.percent_own = 0;
    }
    if (game.percent_own > game.percent_parent) {
      game.percent_own = game.percent_parent;
    }
    game.percent_given = game.percent_parent - game.percent_own;

    if (game.percent_given < 0) {
      game.percent_given = 0;
      game.percent_own = game.percent_parent;
    }

    this.DataChange.emit(this.Data);
  }

  onActiveLottoSetting(game_code: string) {
    this.activeGame = game_code;
    if (game_code == 'ASKMELOTTO') {
      var find = this.Data.profit_sharing.filter(c => c.game_code == game_code);
      if (find.length > 0) {
        this.activeGameListCode = find[0].lotto_amb_betlimit.current[0].game_list_code;
      }
    }
  }

  onActiveLottoSettingAmb(game_list_code: string) {
    this.activeGameListCode = game_list_code;
  }

  onChangeLimitSettingAmb(game_list_code: string) {
    this.DataChange.emit(this.Data);
  }
}
